module.exports = __webpack_public_path__ + "media/assets/images/votorantim-energia@2x-894f3fc6991845731f3f972da7936391.png";